<template>
    <v-select
        :label="campo.rotulo"
        :items="itens"
        :hint="campo.ajuda"
        filled
        :value="value"
        @input="updateValue"
    />
</template>

<script>
import { getServicoDatahubInstance } from "@/services/ServicosFactory";

const servicoDatahub = getServicoDatahubInstance();

function obterItensEstaticos(campo) {
    return Promise.resolve(campo.opcoes.valores);
}

function obterItensDinamicos(campo) {
    return servicoDatahub.obterLista(campo.opcoes.chave).then((resposta) => {
        return resposta.items.map((item) => ({
            texto: item.key,
            valor: item.value,
        }));
    });
}

function obterItens(campo) {
    if (campo.opcoes.tipo === "estaticas") {
        return obterItensEstaticos(campo);
    } else if (campo.opcoes.tipo === "dinamicas") {
        return obterItensDinamicos(campo);
    }
    return Promise.resolve([]);
}

export default {
    name: "caixa-de-selecao",
    props: {
        value: {
            type: String,
        },
        campo: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            itens: [],
        };
    },
    mounted() {
        this.montarItens();
    },
    methods: {
        montarItens() {
            obterItens(this.campo).then((itens) => {
                this.itens = itens.map((item) => ({
                    text: item.texto,
                    value: item.valor,
                }));
            });
        },
        updateValue(value) {
            this.$emit("input", value);
        },
    },
};
</script>

<style></style>
